export default __webpack_public_path__ + "static/viinitie-banner-xmass-desktop-extra-wide.252dfcdcbdacde7b884b7d395c605b72.jpg";